import axios from '../http'
import store from '../store'
import moment from 'moment'

import {version} from '../../package.json';
import LogRocket from 'logrocket'

function login(username, password, impersonate) {
    let url = '/auth'
    if(impersonate) {
      url += '/forgot?username=' + encodeURIComponent(impersonate)
    } else {
      url += '?'
    }
    if(store.state.qcmc) url += '&qcmc=' + encodeURIComponent(store.state.qcmc)
    let data = {
      'username': username,
      'password': password
    }
    return new Promise((resolve, reject) => {
      axios.post(url, data, {skipErrorHandler: true})
        .then(response => {
          store.commit(
            'updateLogin',
            {
              token: response.headers['x-auth-token'],
              refresh: response.headers['x-refresh-token']
            })

          var logRocketEnv = null
          // switch(process.env.NODE_ENV) {
          //   // case 'preprod':
          //   //   logRocketEnv = 'qc-preprod'
          //   //   break
          //   // case 'sandbox':
          //   //   logRocketEnv = 'qc-sandbox'
          //   //   break
          //   case 'production':
          //     logRocketEnv = 'qc-fe'
          //     break
          //   }
            if(window.location.href.includes('logit=true')) {
              logRocketEnv = 'qc-debug'
            }
            if(logRocketEnv && !window.location.href.includes('/#/verify')) {
              console.log('initting logrocket with ' + 'qc-debug/' + logRocketEnv)
              LogRocket.init('qc-debug/' + logRocketEnv, {
                release: version
              })
            }
            resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
}

function logout() {
  return axios.delete('/auth', {headers: {'X-REFRESH-TOKEN': store.state.refresh}})
}

function refreshLogin() {
  console.log("Auth token expired, attempting to refresh.")
  console.log("Expiry was " + store.state.expiry.format())
  console.log("Refresh was " + store.state.autoLogout.format())
  console.log("Now is " + moment().format())
  return new Promise((resolve, reject) => {
    if(moment().isAfter(store.state.autoLogout)) {
      console.log("Cannot refresh auth token, now is after likely refresh time.")
      reject({response: {status:"QC-CANTREFRESH"}})
    }
    axios.get('/auth', {skipErrorHandler: true, headers: {'X-REFRESH-TOKEN': store.state.refresh}})
      .then(response => {
        store.commit(
          'updateLogin',
          {
            token: response.headers['x-auth-token'],
            refresh: response.headers['x-refresh-token']
          })
        console.log("Auth token refreshed.")
        resolve()
      })
      .catch(error => {
        console.log("Failed to refresh auth token.")
        reject(error)
      })
  })
}

function getApiVersionNumber() {
  return axios.get('/info/')
}

function getRegToken(token) {
  return axios.get('/register/' + token)
}

function postRegToken(registration) {
  let url = '/register?'
  if(store.state.qcmc) url += '&qcmc=' + encodeURIComponent(store.state.qcmc)
  return axios.post(url, registration)
}

function putRegCompletion(token, regCompletion) {
  return axios.put('/register/' + token, regCompletion)
}

function resetPassword(username) {
  let url = '/auth/forgot?username=' + encodeURIComponent(username)
  if(store.state.qcmc) url += '&qcmc=' + encodeURIComponent(store.state.qcmc)
  return axios.get(url)
}

function getAccount() {
  return axios.get('/account')
}

function updateAccount(accountUpdateRequest) {
  return axios.put('/account', accountUpdateRequest)
}

function updatePassword(passwordUpdateRequest, passwordResetToken) {
  return new Promise((resolve, reject) => {
    var opts = {}
    if(passwordResetToken) {
      opts.headers = {'X-PASSWORD-RESET-TOKEN': passwordResetToken}
    }
    axios.put('/auth', passwordUpdateRequest, opts)
      .then(response => {
        store.commit(
          'updateLogin',
          {
            token: response.headers['x-auth-token'],
            refresh: response.headers['x-refresh-token']
          })
        console.log("Auth token refreshed on password update")
        resolve()
      })
      .catch(error => {
        console.log("Failed to update password")
        reject(error)
      })
  })
}

function updateCompany(companyUpdateRequest) {
  return axios.put('/company', companyUpdateRequest)
}

function getUsers(query, includePending, orderBy) {
  let params = ''
  if(query) {
    params += 'query=' + query + '&'
  }
  if(includePending) {
    params += 'includePending=' + includePending + '&'
  }
  if(orderBy) {
    params += 'orderBy=' + orderBy + '&'
  }
  return axios.get('/user?' + params)
}

function addUser(addUserRequest) {
  return axios.post('/user', addUserRequest)
}

function updateUser(userUpdateRequest) {
  return axios.put('/user', userUpdateRequest)
}

function deleteUser(username) {
  return axios.delete('/user?username=' + encodeURIComponent(username))
}

function searchAccountCountries(namePartial) {
  return axios.get('/company/country?name=' + namePartial)
}

function searchAccountIndustries(namePartial) {
  return axios.get('/company/industry?name=' + namePartial)
}

function getCreditInfo(noBTToken) {
  return axios.get('/credit' + (noBTToken ? '?includeBTToken=false' : ''))
}

function postStripeSession(stripeSessionRequest) {
  return axios.post('/credit/stripe/session', stripeSessionRequest)
}

function postCreditPurchase(creditPurchaseRequest) {
  return axios.post('/credit', creditPurchaseRequest)
}

function getCreditHistory(historyRequest) {
  let params = ''
  if(historyRequest.page) {
    params += 'page=' + historyRequest.page + '&'
  }
  if(historyRequest.size) {
    params += 'size=' + historyRequest.size + '&'
  }
  return axios.get('/credit/history?' + params)
}

function getInvoice(id) {
  return axios.get('/credit/history/' + id)
}

function listRegions() {
  return new Promise((resolve, reject) => {
    axios.get('/region?size=300')
      .then(response => {
        resolve(response.data.content)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function getChartData() {
  return axios.get('/region/meta')
}

function getNotices(instituteId, type, regionId) {
  let params = ''
  if(instituteId) {
    params += 'instituteId=' + instituteId + '&'
  }
  if(type) {
    params += 'type=' + type + '&'
  }
  if(regionId) {
    params += 'regionId=' + regionId + '&'
  }
  return axios.get('/notice?page=0&size=200&' + params)
}

function requestInstitute(name, country, comment) {
  return axios.post('/institute/', {
    name: name,
    region: {
      name: country
    },
    comment: comment
  })
}

function searchInstituteSummary (instituteSummaryRequest) {
  let params = ''
  if(instituteSummaryRequest.page) {
    params += 'page=' + instituteSummaryRequest.page + '&'
  }
  if(instituteSummaryRequest.size) {
    params += 'size=' + instituteSummaryRequest.size + '&'
  }
  if(instituteSummaryRequest.name) {
    params += 'name=' + encodeURIComponent(instituteSummaryRequest.name) + '&'
  }
  if(instituteSummaryRequest.regionId) {
    params += 'regionId=' + instituteSummaryRequest.regionId + '&'
  }
  if(instituteSummaryRequest.parentId) {
    params += 'parentId=' + instituteSummaryRequest.parentId + '&'
  }
  if(instituteSummaryRequest.fuzzy) {
    params += 'fuzzy=true&'
  }
  return axios.get('/institute/summary?' + params)
}

function getInstitute(id, applicationId, keysAlreadyPopulated, verificationId) {
  let params = ''
  if(applicationId) {
    params += 'applicationId=' + applicationId + '&'
  }
  if(keysAlreadyPopulated && keysAlreadyPopulated.length > 0) {
    params += 'keysAlreadyPopulated=' + keysAlreadyPopulated.join(',') + '&'
  }
  if(verificationId) {
    params += 'verificationId=' + verificationId + '&'
  }
  return axios.get('/institute/' + encodeURIComponent(id) + '?' + params)
}


function getCountryData(limit, months, templateIds) {
  return axios.post('/analytics/countries?limit=' + limit + '&months=' + months, templateIds)
}

function getOverviewData(templateIds) {
  return axios.post('analytics/overview', templateIds)
}

function getVolumeData(data, templateIds) {
  if(data == 24 || data == 12) {
    return axios.post('analytics/volume?range=MONTHLY' + data, templateIds)
  }
  if(data == 52) {
    return axios.post('analytics/volume?range=WEEKLY', templateIds)
  }
  if(data == 30) {
    return axios.post('analytics/volume?range=DAILY', templateIds)
  }
}

function getRevenueData(data, templateIds) {
  if(data == 24 || data == 12) {
    return axios.post('analytics/revenue?range=MONTHLY' + data, templateIds)
  }
  if(data == 52) {
    return axios.post('analytics/revenue?range=WEEKLY', templateIds)
  }
  if(data == 30) {
    return axios.post('analytics/revenue?range=DAILY', templateIds)
  }
}

function getVerificationsData(data, templateIds) {
  if(data == 24 || data == 12) {
    return axios.post('analytics/verifications?range=MONTHLY' + data, templateIds)
  }
  if(data == 52) {
    return axios.post('analytics/verifications?range=WEEKLY', templateIds)
  }
  if(data == 30) {
    return axios.post('analytics/verifications?range=DAILY', templateIds)
  }
}

function getRefData(instituteId, refDataKey, query) {
  return new Promise((resolve, reject) => {
    axios.get('/institute/'+instituteId+'/refdata?key='+refDataKey+'&name='+query+'&size=300')
      .then(response => {
        resolve(response.data.content)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function getPendingVerifications (historyRequest) {
  let params = ''
  if(historyRequest.page) {
    params += 'page=' + historyRequest.page + '&'
  }
  if(historyRequest.size) {
    params += 'size=' + historyRequest.size + '&'
  }
  if(historyRequest.query) {
    params += 'query=' + encodeURIComponent(historyRequest.query) + '&'
  }
  if(historyRequest.fromDate) {
    params += 'fromDate=' + new moment(historyRequest.fromDate).valueOf() + '&'
  }
  if(historyRequest.toDate) {
    params += 'toDate=' + new moment(historyRequest.toDate).add(1, 'days').valueOf() + '&'
  }
  return axios.get('/verification/pending?' + params)
}

function getPendingVerification(verificationId, publicVerification) {
  if(publicVerification) {
    return axios.get('/verification/pending?vkey=' + verificationId)
  } else {
    return axios.get('/verification/pending/' + verificationId)
  }
}

function resolvePendingVerification(verificationId, resolvedVerification) {
  return axios.put('/verification/pending/' + verificationId, resolvedVerification)
}

function getResolvedVerifications (historyRequest) {
  let params = ''
  if(historyRequest.page) {
    params += 'page=' + historyRequest.page + '&'
  }
  if(historyRequest.size) {
    params += 'size=' + historyRequest.size + '&'
  }
  if(historyRequest.query) {
    params += 'query=' + historyRequest.query + '&'
  }
  if(historyRequest.fromDate) {
    params += 'fromDate=' + new moment(historyRequest.fromDate).valueOf() + '&'
  }
  if(historyRequest.toDate) {
    params += 'toDate=' + new moment(historyRequest.toDate).add(1, 'days').valueOf() + '&'
  }
  return axios.get('/verification/resolved?' + params)
}

function getVerificationHistoryLonger (historyRequest, includeAuditHistory) {
  let params = ''
  if(historyRequest.page) {
    params += 'page=' + historyRequest.page + '&'
  }
  if(historyRequest.size) {
    params += 'size=' + historyRequest.size + '&'
  }
  if(historyRequest.query) {
    params += 'query=' + encodeURIComponent(historyRequest.query) + '&'
  }
  if(historyRequest.requestedBy) {
    params += 'requestedBy=' + encodeURIComponent(historyRequest.requestedBy) + '&'
  }
  if(historyRequest.customerReference) {
    params += 'customerReference=' + historyRequest.customerReference + '&'
  }
  if(historyRequest.results) {
    historyRequest.results.forEach(function(result) {
      params += 'results=' + result + '&'
    }, this);
  }
  if(historyRequest.types) {
    historyRequest.types.forEach(function(type) {
      params += 'type=' + type + '&'
    }, this);
  }
  if(historyRequest.fromDate) {
    params += 'fromDate=' + new moment(historyRequest.fromDate).valueOf() + '&'
  }
  if(historyRequest.toDate) {
    params += 'toDate=' + new moment(historyRequest.toDate).add(1, 'days').valueOf() + '&'
  }
  params += 'includeAuditHistory=' + includeAuditHistory
  return axios.get('/verification?' + params)
}

function getVerificationHistory (historyRequest) {
  let params = ''
  if(historyRequest.page) {
    params += 'page=' + historyRequest.page + '&'
  }
  if(historyRequest.size) {
    params += 'size=' + historyRequest.size + '&'
  }
  if(historyRequest.query) {
    params += 'query=' + encodeURIComponent(historyRequest.query) + '&'
  }
  if(historyRequest.requestedBy) {
    params += 'requestedBy=' + encodeURIComponent(historyRequest.requestedBy) + '&'
  }
  if(historyRequest.customerReference) {
    params += 'customerReference=' + historyRequest.customerReference + '&'
  }
  if(historyRequest.results) {
    historyRequest.results.forEach(function(result) {
      params += 'results=' + result + '&'
    }, this);
  }
  if(historyRequest.types) {
    historyRequest.types.forEach(function(type) {
      params += 'type=' + type + '&'
    }, this);
  }
  if(historyRequest.fromDate) {
    params += 'fromDate=' + new moment(historyRequest.fromDate).valueOf() + '&'
  }
  if(historyRequest.toDate) {
    params += 'toDate=' + new moment(historyRequest.toDate).add(1, 'days').valueOf() + '&'
  }
  return axios.get('/verification/summary?' + params)
}

function postVerification(verificationRequest, noSubmit) {
  return axios.post('/verification' + (noSubmit ? '?autosubmit=false' : ''), verificationRequest, {docUpload: true, timeout: 300000})
}

function putVerification(verificationId, verificationRequest, resub, pushToPending) {
  let params = ''
  if(resub) {
    params += 'resub=true&'
  }
  if(pushToPending) {
    params += 'push=true&'
  }
  return axios.put('/verification/' + verificationId + '?' + params, verificationRequest, {docUpload: true, timeout: 300000})
}

function getVerification(verificationId) {
  return axios.get('/verification/' + verificationId)
}

function deleteVerification(verificationId) {
  return axios.delete('/verification/' + verificationId)
}

function getVerificationAuditHistory(verificationId) {
  return axios.get('/verification/' + verificationId + '/auditevent')
}

function getDocument(ownerType, ownerId, documentId) {
  return axios.get('/' + ownerType + '/' + ownerId + '/document/' + documentId, { responseType: 'arraybuffer' })
}

function postDocument(verificationId, documentRequest) {
  return axios.post('/verification/' + verificationId + '/document?autosubmit=false', documentRequest, {docUpload: true, timeout: 300000})
}

function deleteDocument(verificationId, documentId) {
  return axios.delete('/verification/' + verificationId + '/document/' + documentId)
}

function downloadResult(verificationId, brand, ignoreNotes) {
  return axios.get('/verification/' + verificationId + '/downloads/result?ignoreNotes=' + ignoreNotes + '&brand=' + brand , { responseType: 'arraybuffer' })
}

function getVerificationMetaData(resultList) {
  var resultListParam = ''
  if(resultList) {
    resultListParam += '?'
    resultList.forEach(result => {
      resultListParam += ('results=' + result + '&')
    })
  }
  return axios.get('/verification/meta' + resultListParam)
}

function getVerificationShares(verificationId) {
  return axios.get('/verification/' + verificationId + '/share')
}

function postVerificationShare(verificationId, share) {
  return axios.post('/verification/' + verificationId + '/share', share)
}

function deleteVerificationShare(verificationId, id) {
  return axios.delete('/verification/' + verificationId + '/share/' + id)
}

function getWalletShares() {
  return axios.get('/wallet/share')
}

function postWalletShare(share) {
  return axios.post('/wallet/share', share)
}

function deleteWalletShare(id) {
  return axios.delete('/wallet/share/' + id)
}

function getPubliShare(key) {
  return axios.get('/share/' + key)
}

function postRegisterApplicant(invitation) {
  var invite = {
    email: invitation.email,
    firstname: invitation.firstname,
    lastname: invitation.lastname,
    ref: invitation.customerReference,
    applicationTemplateId: invitation.templateId
  }
  return axios.post('/register/applicant', invite, {timeout: 300000})
}

function getApplicationFiltersByTemplate(templateId) {
  return axios.get('/application/filters', { params: { templateId } } )
}

function getApplication(id) {
  return axios.get('/application/' + id)
}

function getApplicationHistory(historyRequest, customFilters) {
  let params = ''
  if(historyRequest.page) {
    params += 'page=' + historyRequest.page + '&'
  }
  if(historyRequest.size) {
    params += 'size=' + historyRequest.size + '&'
  }
  if(historyRequest.query) {
    params += 'query=' + encodeURIComponent(historyRequest.query) + '&'
  }
  if(historyRequest.status) {
    historyRequest.status.forEach(status => {
      params += 'status=' + status + '&'
    });
  }
  if(historyRequest.fromDate) {
    params += 'fromDate=' + new moment(historyRequest.fromDate).valueOf() + '&'
  }
  if(historyRequest.toDate) {
    params += 'toDate=' + new moment(historyRequest.toDate).add(1, 'days').valueOf() + '&'
  }
  if(historyRequest.customerReference) {
    params += 'ref=' + encodeURIComponent(historyRequest.customerReference) + '&'
  }
  if(historyRequest.templateId && historyRequest.templateId != "All") {
    params += 'templateId=' + encodeURIComponent(historyRequest.templateId) + '&'
  }
  if(customFilters && customFilters.length > 0) {
    customFilters.forEach(filter => {
      if(filter.value != null) {
        params += filter.key + '=' + filter.value + '&'
      }
    })
  }
  return axios.get('/application?' + params)
}

function updateApplication(applicationId, updateRequest) {
  return axios.put('application/'+applicationId, updateRequest)
}

function updateApplicationVerifications(applicationId, verificationIds) {
  return axios.put('application/'+applicationId+'/verification', verificationIds)
}

function downloadApplicationResult(applicationId) {
  return axios.get('/application/' + applicationId + '/downloads/result', { responseType: 'arraybuffer' })
}

function getApplicationOwner(id) {
  return axios.get('/application/owner/' + id)
}

function getApplicationTemplateOwner(id) {
  return axios.get('/application/template/owner/' + id)
}

function getApplicantsMetaData(statusList) {
  var statusListParam = ''
  if(statusList) {
    statusListParam += '?'
    statusList.forEach(status => {
      statusListParam += ('status=' + status + '&')
    })
  }
  return axios.get('/application/meta' + statusListParam)
}

function getReferralOwner(referralcode) {
  return axios.get('/referral/owner/' + referralcode)
}

function getReferralList (listRequest) {
  let params = ''
  if(listRequest.query) {
    params += 'query=' + encodeURIComponent(listRequest.query) + '&'
  }
  if(listRequest.page) {
    params += 'page=' + listRequest.page + '&'
  }
  if(listRequest.size) {
    params += 'size=' + listRequest.size + '&'
  }
  return axios.get('/referral?' + params)
}

function getReferralHistory (historyRequest) {
  let params = ''
  if(historyRequest.page) {
    params += 'page=' + historyRequest.page + '&'
  }
  if(historyRequest.size) {
    params += 'size=' + historyRequest.size + '&'
  }
  if(historyRequest.query) {
    params += 'query=' + encodeURIComponent(historyRequest.query) + '&'
  }
  if(historyRequest.organisation) {
    params += 'organisation=' + encodeURIComponent(historyRequest.organisation) + '&'
  }
  if(historyRequest.requestedBy) {
    params += 'requestedBy=' + encodeURIComponent(historyRequest.requestedBy) + '&'
  }
  if(historyRequest.customerReference) {
    params += 'customerReference=' + historyRequest.customerReference + '&'
  }
  if(historyRequest.results) {
    historyRequest.results.forEach(function(result) {
      params += 'results=' + result + '&'
    }, this);
  }
  if(historyRequest.types) {
    historyRequest.types.forEach(function(type) {
      params += 'type=' + type + '&'
    }, this);
  }
  if(historyRequest.fromDate) {
    params += 'fromDate=' + new moment(historyRequest.fromDate).valueOf() + '&'
  }
  if(historyRequest.toDate) {
    params += 'toDate=' + new moment(historyRequest.toDate).add(1, 'days').valueOf() + '&'
  }
  return axios.get('/referral/history?' + params)
}

function postCreditOrder(creditOrder) {
  return axios.post('/credit/order', creditOrder)
}

function getOnifdoToken(dto) {
  return axios.post('/id/init', dto)
}

function getReport(report, dateRange, applicationTemplateId) {
  let params = 'report=' + report + '&'
  if(dateRange && dateRange.length > 0) {
    params += 'fromDate=' + new moment(dateRange[0]).valueOf() + '&'
  }
  if(dateRange && dateRange.length > 1) {
    params += 'toDate=' + new moment(dateRange[1]).valueOf() + '&'
  }
  if(applicationTemplateId) {
    params += 'templateId=' + applicationTemplateId + '&'
  }
  return axios.get('/reports?' + params)
}

function getApprovedByProcess() {
  return axios.get('approvalprocess')
}

function postUnsubscribeData(unsubData) {
  return axios.post('/unsubscribe', unsubData)
}

function getApplicationTemplateIds() {
  return axios.get('/application/template')
}

async function searchVerifications() {
  if (store.state.savedVerificationData.dob !== "" && !store.state.savedVerificationData.dob.includes("_") && // Checking to make sure date is fully inputted
    store.state.savedVerificationData.firstName !== "" &&
    store.state.savedVerificationData.lastName !== "" &&
    store.state.savedVerificationData.instituteId !== "") {
        try {
          const params = {
            instituteId: store.state.savedVerificationData.instituteId,
            firstname: store.state.savedVerificationData.firstName,
            surname: store.state.savedVerificationData.lastName,
            dob: moment(store.state.savedVerificationData.dob, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            fromDate: moment().subtract(1, 'years').toDate().getTime() // Checks against last years data - has to be converted to UNIX which is what this code does
          }
          const response = await axios.get('/verification', { params });
          store.state.previousVerificationData = response.data
        } catch (error) {
          console.error('Error during API call:', error);
        }
      }
    }

    async function getAlertsData() {
      try {
        const params = new URLSearchParams();
        params.append('newsTypes', 'ALERT_MAINTENANCE');
        params.append('newsTypes', 'NEWS');
        params.append('active', 'true');
        const response = await axios.get('/news/alerts/?' + params.toString());
        return response.data;
      } catch (error) {
        console.error('Error fetching alerts data:', error);
        throw error;
      }
    }


export default {
  getOnifdoToken,
  getApiVersionNumber,
  login,
  logout,
  getRegToken,
  postRegToken,
  putRegCompletion,
  refreshLogin,
  resetPassword,
  getAccount,
  updateAccount,
  updatePassword,
  updateCompany,
  getUsers,
  addUser,
  updateUser,
  deleteUser,
  searchAccountCountries,
  searchAccountIndustries,
  getCreditInfo,
  postCreditPurchase,
  postStripeSession,
  getCreditHistory,
  getInvoice,
  listRegions,
  getChartData,
  getNotices,
  requestInstitute,
  getInstitute,
  getCountryData,
  getVerificationsData,
  getRevenueData,
  getOverviewData,
  getVolumeData,
  searchInstituteSummary,
  getRefData,
  getPendingVerifications,
  getPendingVerification,
  resolvePendingVerification,
  getResolvedVerifications,
  getVerificationHistory,
  getVerificationHistoryLonger,
  putVerification,
  postVerification,
  getVerification,
  deleteVerification,
  getVerificationAuditHistory,
  getDocument,
  postDocument,
  deleteDocument,
  downloadResult,
  getVerificationMetaData,
  getVerificationShares,
  postVerificationShare,
  deleteVerificationShare,
  getWalletShares,
  postWalletShare,
  deleteWalletShare,
  getPubliShare,
  postRegisterApplicant,
  getApplicationFiltersByTemplate,
  getApplication,
  getApplicationHistory,
  updateApplication,
  updateApplicationVerifications,
  downloadApplicationResult,
  getApplicationOwner,
  getApplicationTemplateOwner,
  getApplicantsMetaData,
  postCreditOrder,
  getReferralOwner,
  getReferralList,
  getReferralHistory,
  getReport,
  getApprovedByProcess,
  searchVerifications,
  getAlertsData,
  postUnsubscribeData,
  getApplicationTemplateIds
}
